export default "  <pagesnavbar-cmp></pagesnavbar-cmp>\n  <router-outlet></router-outlet>\n"